import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ExameSegModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const beneficios = [
    {
      id: 1,
      titulo: 'Alcance Nacional',
      descricao: 'Agende seus exames em qualquer lugar do Brasil! A ExameSeg faz parte de um ecossistema integrado com clínicas em todo o país, garantindo que você tenha acesso aos melhores serviços, onde quer que esteja.',
      icone: (
        <svg className="w-6 h-6 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    {
      id: 2,
      titulo: 'E-Social + ASO',
      descricao: 'Todos os seus exames são compatíveis com o E-Social. Receba automaticamente o Atestado de Saúde Ocupacional (ASO) e os documentos necessários para envio ao E-Social.',
      icone: (
        <svg className="w-6 h-6 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      )
    },
    {
      id: 3,
      titulo: 'Risco e Exames Complementares',
      descricao: 'Nosso sistema identifica automaticamente os exames necessários com base nos riscos da função. Se precisar de exames adicionais, você pode incluí-los facilmente.',
      icone: (
        <svg className="w-6 h-6 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      )
    }
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black z-40"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-x-4 top-[10%] md:inset-x-auto md:left-1/2 md:-translate-x-1/2 md:max-w-2xl bg-white rounded-2xl shadow-2xl z-50 overflow-y-auto max-h-[80vh] my-4"
          >
            <div className="relative p-6 md:p-8">
              {/* Botão Fechar */}
              <button
                onClick={onClose}
                className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              {/* Cabeçalho */}
              <div className="text-center mb-8">
                <img
                  src="/logos/exameseg-color.png"
                  alt="ExameSeg Logo"
                  className="h-12 mx-auto mb-6"
                />
                <h2 className="text-3xl font-bold text-teal-900 mb-4">
                  Agende seus exames ocupacionais de forma <span className="text-emerald-500">fácil e rápida!</span>
                </h2>
                <p className="text-gray-600 text-lg mb-6">
                  Cansado de perder tempo procurando clínicas e fazendo orçamentos por WhatsApp para agendar exames admissionais, demissionais ou periódicos?
                </p>
                <p className="text-gray-700 text-lg font-medium">
                  Com a ExameSeg, você <span className="text-emerald-500">agenda, paga e confirma</span> seus exames online em poucos minutos. Tudo de forma simples e prática!
                </p>
              </div>

              {/* Benefícios */}
              <div className="space-y-6 mb-8">
                <h3 className="text-xl font-bold text-teal-900 mb-4">
                  Quais <span className="text-emerald-500">benefícios</span> de escolher a ExameSeg?
                </h3>
                <p className="text-gray-600 mb-6">
                  Temos três características que vão resolver todos os seus problemas quando o assunto são Exames:
                </p>
                {beneficios.map((beneficio) => (
                  <div
                    key={beneficio.id}
                    className="bg-teal-900 rounded-lg p-6 text-white"
                  >
                    <div className="flex items-start gap-4">
                      <div className="bg-emerald-400/20 rounded-full p-3 mt-1">
                        {beneficio.icone}
                      </div>
                      <div>
                        <h4 className="text-lg font-semibold mb-2">{beneficio.titulo}</h4>
                        <p className="text-teal-50/90 leading-relaxed">{beneficio.descricao}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Botões de Ação */}
              <div className="flex justify-center">
                <a
                  href="https://exameseg.com.br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-emerald-500 hover:bg-emerald-600 text-white text-center font-semibold py-3 px-12 rounded-lg transition-colors"
                >
                  Saiba mais
                </a>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default ExameSegModal;